"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- FADE : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'Fade',
  group: _definitionhelpers.groupNames.graphics,
  props: {
    marginTop: {
      type: 'number',
      default: 120,
      help: {
        title: 'Fade Margins',
        desc: "Normally this component has a marginTop of -120 and is pulled up over the item above it. Change the value to a negative to see the difference.",
        link: {}
      }
    }
  }
};
exports.default = _default;